import { Injectable } from '@angular/core';
import { AuthService } from '@klickdata/core/auth/src/token/auth.service';
import { ConfigService } from '@klickdata/core/config/src/config.service';
import { RequestBuilderService } from '@klickdata/core/http/src/request/request-builder.service';
import { Utils } from '@klickdata/core/util';
import { map, Observable } from 'rxjs';
import { OccasionsDates, OccasionsDatesData } from './occasions-dates.model';

@Injectable({
    providedIn: 'root',
})
export class OccasionsDatesService {
    protected resourceUrl: string;

    constructor(
        protected auth: AuthService,
        protected builder: RequestBuilderService,
        protected config: ConfigService
    ) {
        this.resourceUrl = `${this.config.config.apiUrl}occasion-dates`;
    }
    createOccasionDate(resourceId: number, data: OccasionsDatesData): Observable<OccasionsDates> {
        return this.builder
            .post<OccasionsDatesData>(`${this.resourceUrl}`, { ...data, resource_id: resourceId })
            .request()
            .pipe(map((res) => this.mapOccasionDate(res.data)));
    }
    public mapOccasionDate(data: OccasionsDatesData): OccasionsDates {
        const occasion = new OccasionsDates(data);

        occasion.hasAvailableSeats =
            (occasion.total_seats > 0 && occasion.total_seats > occasion.approved_count) ||
            occasion.total_seats == null ||
            occasion.total_seats == 0;
        occasion.hasValidDate =
            Utils.getEnrollAbility(occasion) === 'enrollable' ||
            Utils.getEnrollAbility(occasion) !== 'nonEnrollable' ||
            (Utils.getEnrollAbility(occasion) === 'neutral' && Utils.isValidToStartOccasionByDate(occasion));
        occasion.ispassed = Utils.isOccasionDatePassed(occasion);

        return occasion;
    }
}
